export default __webpack_public_path__ + "static/media/calendar-desktop.5d877d3d.png";